export default "__VITE_ASSET__CikcQVid__"